module.exports = __webpack_public_path__ + "img/lf4.dbab2d13.png";